document.addEventListener('product:variant-change', (event) => {

  const variant = event.detail.variant;
    console.log(variant, 'Variant Change BD PDP');
  if (!variant || !variant.featured_media) return;

  const targetPosition = variant.featured_media.position;

  // Find the slide with that position
  const slides = document.querySelectorAll('[data-media-position]');
  let targetIndex = 0;

  slides.forEach((slide, index) => {
    if (Number(slide.dataset.mediaPosition) === targetPosition) {
      targetIndex = index;
    }
  });

  // Scroll Embla to that slide
  const slider = document.querySelector('.product-media')?.closest('bd-slider');
  slider?.scrollTo?.(targetIndex);
});

 
 